// src/components/Contact.jsx
import React from "react";
import "./Contact.css";

/* optional dummy submit – replace with actual handler/API */
const handleSubmit = e => {
  e.preventDefault();
  alert("Thanks – your message has been sent!");
};

const OFFICES = [
  {
    key: "orchards",
    label: "Akasia (The Orchards), Pretoria",
    addressLines: [
      "59A Kirkness Rd",
      "The Orchards, Akasia",
      "0182",
      "South Africa",
    ],
    // original embed from your code
    embedSrc:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3574.955602505628!2d28.10456847549878!3d-25.656799229335886!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1e9562e75f3b361f%3A0x28204e4b8469718d!2s59A%20Kirkness%20Rd%2C%20The%20Orchards%2C%20Akasia%2C%200182!5e0!3m2!1sen!2sza!4v1716734520000",
  },
  {
    key: "polokwane",
    label: "Bendor, Polokwane",
    addressLines: [
      "47 The Glen @ Woodlands",
      "79 Buffalo Thorn Cres Street",
      "Bendor",
      "Polokwane",
      "0699",
      "South Africa",
    ],
    embedFromAddress:
      "47 The Glen @ Woodlands, 79 Buffalo Thorn Cres Street, Bendor, Polokwane, 0699, South Africa",
  },
];

const buildEmbed = o =>
  o.embedSrc ||
  `https://www.google.com/maps?q=${encodeURIComponent(
    o.embedFromAddress
  )}&output=embed`;

export default function Contact() {
  return (
    <section className="contact" id="contact">
      {/* scoped styles so this is fully drop-in */}
      <style>{`
        .contact .row {
          display: grid;
          gap: 2rem;
        }
        @media (min-width: 992px) {
          .contact .row {
            grid-template-columns: 1.4fr 1fr; /* left: offices, right: form */
            align-items: start;
          }
        }

        .offices-grid {
          display: grid;
          gap: 1.25rem;
        }
        @media (min-width: 720px) {
          .offices-grid {
            grid-template-columns: 1fr 1fr; /* two office cards side-by-side */
          }
        }

        .office-card {
          background: #fff;
          border: 1px solid #e9e9e9;
          border-radius: 10px;
          padding: 0.85rem;
          box-shadow: 0 2px 10px rgba(0,0,0,.05);
        }
        .office-title {
          font-weight: 700;
          margin: 0 0 .25rem;
        }
        .office-address {
          margin: 0 0 .5rem;
          font-size: .95rem;
          line-height: 1.35;
          color: #333;
        }
        .map {
          width: 100%;
          min-height: 240px;
          border: 0;
          border-radius: 8px;
        }
        @media (min-width: 1200px) {
          .map { min-height: 300px; }
        }
      `}</style>

      <h1 className="heading">contact&nbsp;us</h1>

      <div className="row">
        {/* LEFT: both offices at once */}
        <div className="offices-grid">
          {OFFICES.map(o => (
            <div key={o.key} className="office-card">
              <div className="office-title">{o.label}</div>
              <address className="office-address">
                {o.addressLines.map((l, i) => (
                  <div key={i}>{l}</div>
                ))}
              </address>
              <iframe
                className="map"
                title={`${o.label} Map`}
                loading="lazy"
                allowFullScreen
                src={buildEmbed(o)}
              />
            </div>
          ))}
        </div>

        {/* RIGHT: your contact form (unchanged) */}
        <form onSubmit={handleSubmit} noValidate>
          <h3>get in touch</h3>

          <input
            type="text"
            name="name"
            placeholder="name"
            required
            className="box"
          />

          <input
            type="email"
            name="email"
            placeholder="email"
            required
            className="box"
          />

          <input
            type="tel"
            name="phone"
            placeholder="phone"
            pattern="[0-9+ ]{7,}"
            className="box"
          />

          <textarea
            name="message"
            placeholder="message"
            className="box"
            rows={8}
            required
          />

          <button type="submit" className="btn contact-btn">
            send&nbsp;message
          </button>
        </form>
      </div>
    </section>
  );
}
